<template>
  <div>
    <el-dialog title="推币充值" :visible="visible" @close="onClose" :show-close="false">
      <img :src="wating">
      <p class="title mt24">请在支付宝页面中完成支付</p>
      <zt-wrap height="22px" class="link">
        <a :href="payUrl" target="_blank">重新打开支付链接</a>
      </zt-wrap>
      
      <zt-wrap height="16px"></zt-wrap>
      <zt-button plain type="primary" size="medium" width="140px">遇到问题？</zt-button>
      <zt-button class="ml20" type="primary" size="medium" width="140px" @click="onSuccess()" :loading="loading">已完成支付</zt-button>
    </el-dialog>

    <success-dialog v-model="successVisible"/>
    <fail-dialog v-model="failVisible"/>
  </div>
</template>

<script>
import visibleMixins from './mixins/dialogVisible'
import imgMixins from './mixins/dialogImg'
import failDialog from './failDialog'
import successDialog from './successDialog'
import { taoke_charge_query } from '@/api/myCenter'
export default {
  name: 'rechangeDialog',
  mixins: [ visibleMixins, imgMixins ],
  components: { successDialog, failDialog },

  props: {
    orderno: [ Number, String ],
    payUrl: String,
  },

  data: () => ({
    successVisible: false,
    failVisible: false,
    loading: false,
  }),

  methods: {
    async onSuccess() {
      this.loading = true
      const { data } = await taoke_charge_query(this.orderno)
      this.onClose()
      if (data.error_code == 0) {
        if (data.status == 0) {
          this.failVisible = true
        }
        else {
          this.successVisible = true
          await this.$store.dispatch('GetUserInfo')
        }
      }
      else {
        this.$message.error(data.error_message)
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import './styles/dialog.scss';
</style>